import { render, staticRenderFns } from "./failed-bid.vue?vue&type=template&id=87943080&scoped=true"
import script from "./failed-bid.vue?vue&type=script&lang=js"
export * from "./failed-bid.vue?vue&type=script&lang=js"
import style0 from "./failed-bid.vue?vue&type=style&index=0&id=87943080&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87943080",
  null
  
)

export default component.exports